import React from "react";
import Layout from "../../Components/Layout";
import BannerGlobal from "../../Components/BannerGlobal";
import BrandLogos from "../../Components/BrandLogos";
import Blogs from "../../Components/Blogs";
import useDocumentTitle from "../../Hooks/PageTitle";

const BlogsPage = () => {
  useDocumentTitle("TRoo Construction | Blogs ");
  return (
    <Layout>
      <BannerGlobal />
      <Blogs />
      <BrandLogos />
    </Layout>
  );
};

export default BlogsPage;
